import CallToAction from "components/CallToAction"
import Image from "components/Image"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function PageHeaderWithImage({ blok }) {
  return (
    <header className="px-8 mb-6 bg-heroBanner bg-left-top 2xl:bg-bottom bg-cover">
      <div className="max-w-screen-xl mx-auto pt-16 lg:pt-20 min-h-[257px] flex flex-col lg:flex-row gap-6 justify-between lg:items-center w-full">
        <div>
          <h1 className="break-words pb-6 lg:pb-12">{blok.heading}</h1>
          {blok?.cta_label && getStoryblokLink(blok?.cta_link) ? (
            <CallToAction href={getStoryblokLink(blok.cta_link)}>{blok.cta_label}</CallToAction>
          ) : null}
        </div>
        {blok?.image?.filename ? (
          <Image
            src={blok.image.filename}
            alt={blok.image.alt}
            width={463}
            height={309}
            className="w-full lg:w-auto lg:max-h-[309px]"
          />
        ) : null}
      </div>
    </header>
  )
}
